import { ReactComponent as NoDataSVG } from "../images/no_data.svg";

export default function DownloadError() {

  return (
    <>
      <div className="bg-white border-4 flex flex-col rounded-lg mx-auto lg:relative min-h-[60vh]">
        <div className="flex-grow flex flex-col">
          <main className="flex-grow flex flex-col bg-white ">
            <div className="flex-grow mx-auto max-w-7xl w-full flex flex-col px-4 sm:px-6 lg:px-8 ">
              <div className="flex-shrink-0 my-auto py-16">
                <h1 className="mt-2 text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                  Form Expired
                </h1>
                <p className="mt-2 text-base text-gray-500">
                  Sorry, the form has now expired as it has been more than 7 days.
                </p>
                <div className="mt-6">
                  <a
                    href="/"
                    className="text-base font-medium text-[#3059a9] hover:text-indigo-500"
                  >
                    Go back home<span aria-hidden="true"> &rarr;</span>
                  </a>
                </div>
              </div>
            </div>
          </main>
        </div>
        <div className="m-auto mb-14"><NoDataSVG className=" container" /></div>
      </div>
    </>
  );
}